// extracted by mini-css-extract-plugin
module.exports =  {"markdownStyles":"Markdown-module__markdownStyles--hf_0h"};